var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46885",
    "data-name": "Group 46885",
    transform: "translate(-130 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile_01",
    "data-name": "profile 01",
    transform: "translate(130 188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1322",
    "data-name": "Ellipse 1322",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(0)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53384",
    "data-name": "Path 53384",
    d: "M822.142,243a1.317,1.317,0,0,0,.832-1.034l2.775-18.4a1.318,1.318,0,0,0-1.977-1.33l-15.684,9.32a1.318,1.318,0,0,0-.167,2.148l3.558,2.945a1.318,1.318,0,0,0,1.681-2.031l-2.117-1.752,11.685-6.943-2.012,13.343-2.07-1.711a1.318,1.318,0,0,0-1.383-.185l-1.29.583L818.433,235a1.318,1.318,0,0,0-2.027-1.685l-6.119,7.361a1.318,1.318,0,0,0,1.556,2.043l5.757-2.6,3.231,2.671a1.317,1.317,0,0,0,1.311.215Z",
    transform: "translate(-800.152 -216.222)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon1);
export default __webpack_public_path__ + "static/media/profile-icon-1.2a98741a.svg";
export { ForwardRef as ReactComponent };